module.exports = __webpack_public_path__ + "static/media/cg-logo.276edc35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cg-logo.svg
// module id = 104
// module chunks = 0 1 2